import Button from "./Button";
import Card from "./Card";
import "./LongCardsCloud.css";
import { ReactComponent as FourPointsNarrow } from "./static/icons/FourPointsNarrow.svg";
import { ReactComponent as Atom } from "./static/icons/Atom.svg";
import { useState } from "react";

function shuffle(array) {
  let currentIndex = array.length,
    randomIndex;

  // While there remain elements to shuffle.
  while (currentIndex != 0) {
    // Pick a remaining element.
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex],
      array[currentIndex],
    ];
  }
  return array;
}

const generateInitialCords = (cardTexts, CARD_DIMENSIONS) => {
  const cords = [];
  cardTexts.forEach((val, i) => {
    cords.push({ x: 0, y: i * CARD_DIMENSIONS.y });
  });

  return cords;
};

function LongCardsCloud({ cardTexts }) {
  const CARD_DIMENSIONS = { x: 425, y: 85 };
  const [cardCoordinates, setCardCoordinates] = useState(
    generateInitialCords(cardTexts, CARD_DIMENSIONS)
  );
  const [refresh, setRefresh] = useState(false);

  const shuffleCards = () => {
    setCardCoordinates(shuffle(cardCoordinates));
    setRefresh(!refresh);
  };

  return (
    <div>
      <div
        style={{
          position: "relative",
          height: CARD_DIMENSIONS.y * cardTexts.length,
          width: "100%",
        }}
      >
        {cardTexts.map((text, i) => {
          if (!cardCoordinates[i]) {
            return;
          }
          return (
            <div>
              <Card
                variant="fullWidth"
                text={text}
                icon={<FourPointsNarrow />}
                x={cardCoordinates[i].x}
                y={cardCoordinates[i].y}
              />
            </div>
          );
        })}
      </div>
      <Button
        className="ShuffleButton"
        variant="complex"
        text="SHUFFLE CARDS"
        icon={<Atom />}
        onClick={shuffleCards}
      />
    </div>
  );
}

export default LongCardsCloud;
